module.exports = __webpack_public_path__ + "static/media/Elegant_theme.d270c252.png";